 //Carousel
 $('.theme-carousel').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  autoplay: false,
  draggable: false,
  prevArrow: $('.theme-carousel-controls .prev'),
  nextArrow: $('.theme-carousel-controls .next'),
  responsive: [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});